@if (displayScoreSignal() || displayBankruptcySignal()) {
<section>
    <span class="multi-action">
    <div class="title-container score-container">
        @if (displayScoreSignal()) {
            <label class="title" [class.selected]="scoreTab == 'Credit'"
                (click)="scoreTab='Credit'">
                {{'Case.DebtorCreditScore' | translate}}
            </label>
        }

        @if (displayBankruptcySignal() && caseModelSignal()?.debtor?.socialNumber && !caseModelSignal()?.debtor?.isPerson) {
            <label class="title" [class.selected]="scoreTab == 'Bankruptcy'"
                (click)="scoreTab='Bankruptcy'">
                {{'Case.DebtorBankruptcyScore' | translate}}
            </label>
        }
        
        <hr class="separation-line" />
    </div>
    </span>

    @switch (scoreTab) {
        @case ('Credit') {
            <app-credit-score [debtorId]="this.caseModelSignal()?.debtor?.id"></app-credit-score>
        }
        @case ('Bankruptcy') {
            <app-bankruptcy-score [score]="bankruptcyScoreSignal()"></app-bankruptcy-score>
        }
    }
</section>
}      